import { render, staticRenderFns } from "./WaysToUse.vue?vue&type=template&id=09f0df74&scoped=true&"
import script from "./WaysToUse.vue?vue&type=script&lang=js&"
export * from "./WaysToUse.vue?vue&type=script&lang=js&"
import style0 from "./WaysToUse.vue?vue&type=style&index=0&id=09f0df74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0df74",
  null
  
)

export default component.exports